// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"96dcf2f4","320":"d43a6e2c","453":"d273dad3","905":"9902a39b"}[chunkId] + ".chunk.js";
};